import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "danh_gia";

moduleApi.create = (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.getStar = (id) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getStar",
    value: { doi_tuong_ids: id }
  };
  return ApiService(api);
};

moduleApi.getSortableStar = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getSortableStar",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.getSortableStarTotal = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getSortableStarTotal",
    value: dataFilter
  };
  return ApiService(api);
};
moduleApi.getSortableStarForTourist = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getSortableStarForTourist",
    value: dataFilter
  };
  return ApiService(api);
}; 
moduleApi.getSortableStarForTouristTotal = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getSortableStarForTouristTotal",
    value: dataFilter
  };
  return ApiService(api);
}; 
moduleApi.getSortableStarForSafePlace = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getSortableStarForSafePlace",
    value: dataFilter
  };
  return ApiService(api);
}; 
moduleApi.getSortableStarForSafePlaceTotal = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getSortableStarForSafePlaceTotal",
    value: dataFilter
  };
  return ApiService(api);
}; 
moduleApi.getCompanyStar = () => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "dashboard_getCompanyStarStatistics",
    value: {}
  };
  return ApiService(api);
};

export default moduleApi;
